"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useThreeStats = exports.ThreeStatsProvider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var realms_three_1 = __importDefault(require("realms-three"));
var ThreeStatsContext = (0, react_1.createContext)(null);
var ThreeStatsProvider = function (_a) {
    var children = _a.children;
    var statsRef = (0, react_1.useRef)([]);
    if (statsRef.current.length === 0) {
        var stats1 = new realms_three_1.default.STDLIB.Stats();
        stats1.showPanel(0);
        stats1.dom.style.position = "static";
        var stats2 = new realms_three_1.default.STDLIB.Stats();
        stats2.showPanel(1);
        stats2.dom.style.position = "static";
        var stats3 = new realms_three_1.default.STDLIB.Stats();
        stats3.showPanel(2);
        stats3.dom.style.position = "static";
        statsRef.current.push(stats1, stats2, stats3);
    }
    return ((0, jsx_runtime_1.jsx)(ThreeStatsContext.Provider, { value: {
            stats: statsRef.current,
        }, children: children }));
};
exports.ThreeStatsProvider = ThreeStatsProvider;
var useThreeStats = function () {
    return (0, react_1.useContext)(ThreeStatsContext);
};
exports.useThreeStats = useThreeStats;
